// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgenciaGeoMadridRouteImport } from './routes/agencia-geo-madrid'
import { Route as AgenciaSeoRouteImport } from './routes/agencia-seo'
import { Route as AgenciaSeoCercaDeMiRouteImport } from './routes/agencia-seo-cerca-de-mi'
import { Route as AgenciaSeoMadridRouteImport } from './routes/agencia-seo-madrid'
import { Route as AgendaConsultoriaRouteImport } from './routes/agenda-consultoria'
import { Route as AngelRuzRouteImport } from './routes/angel-ruz'
import { Route as CasosExitoRouteImport } from './routes/casos-exito'
import { Route as ComoFuncionaSeoLocalIaRouteImport } from './routes/como-funciona-seo-local-ia'
import { Route as ConsultorSeoMadridRouteImport } from './routes/consultor-seo-madrid'
import { Route as CualMejorAgenciaSeoIaEspanaRouteImport } from './routes/cual-mejor-agencia-seo-ia-espana'
import { Route as DondeContratarSeoLocalCercaRouteImport } from './routes/donde-contratar-seo-local-cerca'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as IntegracionIaSeoRouteImport } from './routes/integracion-ia-seo'
import { Route as MasServiciosRouteImport } from './routes/mas-servicios'
import { Route as PosicionamientoWebRouteImport } from './routes/posicionamiento-web'
import { Route as PosicionamientoWebMadridRouteImport } from './routes/posicionamiento-web-madrid'
import { Route as ProgramaAgenciasRouteImport } from './routes/programa-agencias'
import { Route as QuienesSomosRouteImport } from './routes/quienes-somos'
import { Route as SeoDashboardRouteImport } from './routes/seo-dashboard'
import { Route as SeoLocalVsGeoPosicionamientoRouteImport } from './routes/seo-local-vs-geo-posicionamiento'
import { Route as SobreNosotrosRouteImport } from './routes/sobre-nosotros'
import { Route as ZonasExclusivasRouteImport } from './routes/zonas-exclusivas'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as BlogAtlasChatgptSeoLocalRouteImport } from './routes/blog/atlas-chatgpt-seo-local'
import { Route as BlogVisibilidadIaEmpresasRouteImport } from './routes/blog/visibilidad-ia-empresas'
import { Route as CrmIndexRouteImport } from './routes/crm/index'
import { Route as CrmLoginRouteImport } from './routes/crm/login'
import { Route as LegalCondicionesUsoRouteImport } from './routes/legal/condiciones-uso'
import { Route as LegalCookiesRouteImport } from './routes/legal/cookies'
import { Route as LegalPrivacidadRouteImport } from './routes/legal/privacidad'
import { Route as LegalTerminosServicioRouteImport } from './routes/legal/terminos-servicio'
import { Route as ServiciosCreacionEcommerceShopifyRouteImport } from './routes/servicios/creacion-ecommerce-shopify'
import { Route as ServiciosCreacionWebReactRouteImport } from './routes/servicios/creacion-web-react'
import { Route as ServiciosGeoSeo360RouteImport } from './routes/servicios/geo-seo-360'
import { Route as ServiciosGestionResenasIaRouteImport } from './routes/servicios/gestion-resenas-ia'
import { Route as ServiciosGoogleMerchantIaRouteImport } from './routes/servicios/google-merchant-ia'
import { Route as ServiciosLinkBuildingInteligenteRouteImport } from './routes/servicios/link-building-inteligente'
import { Route as ServiciosPublicidadSemIaRouteImport } from './routes/servicios/publicidad-sem-ia'
import { Route as ServiciosSeoEcommerceIaRouteImport } from './routes/servicios/seo-ecommerce-ia'
import { Route as ServiciosSeoLocalIaRouteImport } from './routes/servicios/seo-local-ia'
import { Route as ServiciosSeoWebIaRouteImport } from './routes/servicios/seo-web-ia'
import { Route as ServiciosSeoEcommerceCiudadRouteImport } from './routes/servicios/seo-ecommerce/$ciudad'
import { Route as ServiciosSeoLocalCiudadRouteImport } from './routes/servicios/seo-local/$ciudad'
import { Route as ServiciosSeoWebCiudadRouteImport } from './routes/servicios/seo-web/$ciudad'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgenciaGeoMadridRoute = AgenciaGeoMadridRouteImport.update({
            id: '/agencia-geo-madrid',path: '/agencia-geo-madrid',getParentRoute: () => rootRouteImport
          })
const AgenciaSeoRoute = AgenciaSeoRouteImport.update({
            id: '/agencia-seo',path: '/agencia-seo',getParentRoute: () => rootRouteImport
          })
const AgenciaSeoCercaDeMiRoute = AgenciaSeoCercaDeMiRouteImport.update({
            id: '/agencia-seo-cerca-de-mi',path: '/agencia-seo-cerca-de-mi',getParentRoute: () => rootRouteImport
          })
const AgenciaSeoMadridRoute = AgenciaSeoMadridRouteImport.update({
            id: '/agencia-seo-madrid',path: '/agencia-seo-madrid',getParentRoute: () => rootRouteImport
          })
const AgendaConsultoriaRoute = AgendaConsultoriaRouteImport.update({
            id: '/agenda-consultoria',path: '/agenda-consultoria',getParentRoute: () => rootRouteImport
          })
const AngelRuzRoute = AngelRuzRouteImport.update({
            id: '/angel-ruz',path: '/angel-ruz',getParentRoute: () => rootRouteImport
          })
const CasosExitoRoute = CasosExitoRouteImport.update({
            id: '/casos-exito',path: '/casos-exito',getParentRoute: () => rootRouteImport
          })
const ComoFuncionaSeoLocalIaRoute = ComoFuncionaSeoLocalIaRouteImport.update({
            id: '/como-funciona-seo-local-ia',path: '/como-funciona-seo-local-ia',getParentRoute: () => rootRouteImport
          })
const ConsultorSeoMadridRoute = ConsultorSeoMadridRouteImport.update({
            id: '/consultor-seo-madrid',path: '/consultor-seo-madrid',getParentRoute: () => rootRouteImport
          })
const CualMejorAgenciaSeoIaEspanaRoute = CualMejorAgenciaSeoIaEspanaRouteImport.update({
            id: '/cual-mejor-agencia-seo-ia-espana',path: '/cual-mejor-agencia-seo-ia-espana',getParentRoute: () => rootRouteImport
          })
const DondeContratarSeoLocalCercaRoute = DondeContratarSeoLocalCercaRouteImport.update({
            id: '/donde-contratar-seo-local-cerca',path: '/donde-contratar-seo-local-cerca',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const IntegracionIaSeoRoute = IntegracionIaSeoRouteImport.update({
            id: '/integracion-ia-seo',path: '/integracion-ia-seo',getParentRoute: () => rootRouteImport
          })
const MasServiciosRoute = MasServiciosRouteImport.update({
            id: '/mas-servicios',path: '/mas-servicios',getParentRoute: () => rootRouteImport
          })
const PosicionamientoWebRoute = PosicionamientoWebRouteImport.update({
            id: '/posicionamiento-web',path: '/posicionamiento-web',getParentRoute: () => rootRouteImport
          })
const PosicionamientoWebMadridRoute = PosicionamientoWebMadridRouteImport.update({
            id: '/posicionamiento-web-madrid',path: '/posicionamiento-web-madrid',getParentRoute: () => rootRouteImport
          })
const ProgramaAgenciasRoute = ProgramaAgenciasRouteImport.update({
            id: '/programa-agencias',path: '/programa-agencias',getParentRoute: () => rootRouteImport
          })
const QuienesSomosRoute = QuienesSomosRouteImport.update({
            id: '/quienes-somos',path: '/quienes-somos',getParentRoute: () => rootRouteImport
          })
const SeoDashboardRoute = SeoDashboardRouteImport.update({
            id: '/seo-dashboard',path: '/seo-dashboard',getParentRoute: () => rootRouteImport
          })
const SeoLocalVsGeoPosicionamientoRoute = SeoLocalVsGeoPosicionamientoRouteImport.update({
            id: '/seo-local-vs-geo-posicionamiento',path: '/seo-local-vs-geo-posicionamiento',getParentRoute: () => rootRouteImport
          })
const SobreNosotrosRoute = SobreNosotrosRouteImport.update({
            id: '/sobre-nosotros',path: '/sobre-nosotros',getParentRoute: () => rootRouteImport
          })
const ZonasExclusivasRoute = ZonasExclusivasRouteImport.update({
            id: '/zonas-exclusivas',path: '/zonas-exclusivas',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogAtlasChatgptSeoLocalRoute = BlogAtlasChatgptSeoLocalRouteImport.update({
            id: '/blog/atlas-chatgpt-seo-local',path: '/blog/atlas-chatgpt-seo-local',getParentRoute: () => rootRouteImport
          })
const BlogVisibilidadIaEmpresasRoute = BlogVisibilidadIaEmpresasRouteImport.update({
            id: '/blog/visibilidad-ia-empresas',path: '/blog/visibilidad-ia-empresas',getParentRoute: () => rootRouteImport
          })
const CrmIndexRoute = CrmIndexRouteImport.update({
            id: '/crm/',path: '/crm/',getParentRoute: () => rootRouteImport
          })
const CrmLoginRoute = CrmLoginRouteImport.update({
            id: '/crm/login',path: '/crm/login',getParentRoute: () => rootRouteImport
          })
const LegalCondicionesUsoRoute = LegalCondicionesUsoRouteImport.update({
            id: '/legal/condiciones-uso',path: '/legal/condiciones-uso',getParentRoute: () => rootRouteImport
          })
const LegalCookiesRoute = LegalCookiesRouteImport.update({
            id: '/legal/cookies',path: '/legal/cookies',getParentRoute: () => rootRouteImport
          })
const LegalPrivacidadRoute = LegalPrivacidadRouteImport.update({
            id: '/legal/privacidad',path: '/legal/privacidad',getParentRoute: () => rootRouteImport
          })
const LegalTerminosServicioRoute = LegalTerminosServicioRouteImport.update({
            id: '/legal/terminos-servicio',path: '/legal/terminos-servicio',getParentRoute: () => rootRouteImport
          })
const ServiciosCreacionEcommerceShopifyRoute = ServiciosCreacionEcommerceShopifyRouteImport.update({
            id: '/servicios/creacion-ecommerce-shopify',path: '/servicios/creacion-ecommerce-shopify',getParentRoute: () => rootRouteImport
          })
const ServiciosCreacionWebReactRoute = ServiciosCreacionWebReactRouteImport.update({
            id: '/servicios/creacion-web-react',path: '/servicios/creacion-web-react',getParentRoute: () => rootRouteImport
          })
const ServiciosGeoSeo360Route = ServiciosGeoSeo360RouteImport.update({
            id: '/servicios/geo-seo-360',path: '/servicios/geo-seo-360',getParentRoute: () => rootRouteImport
          })
const ServiciosGestionResenasIaRoute = ServiciosGestionResenasIaRouteImport.update({
            id: '/servicios/gestion-resenas-ia',path: '/servicios/gestion-resenas-ia',getParentRoute: () => rootRouteImport
          })
const ServiciosGoogleMerchantIaRoute = ServiciosGoogleMerchantIaRouteImport.update({
            id: '/servicios/google-merchant-ia',path: '/servicios/google-merchant-ia',getParentRoute: () => rootRouteImport
          })
const ServiciosLinkBuildingInteligenteRoute = ServiciosLinkBuildingInteligenteRouteImport.update({
            id: '/servicios/link-building-inteligente',path: '/servicios/link-building-inteligente',getParentRoute: () => rootRouteImport
          })
const ServiciosPublicidadSemIaRoute = ServiciosPublicidadSemIaRouteImport.update({
            id: '/servicios/publicidad-sem-ia',path: '/servicios/publicidad-sem-ia',getParentRoute: () => rootRouteImport
          })
const ServiciosSeoEcommerceIaRoute = ServiciosSeoEcommerceIaRouteImport.update({
            id: '/servicios/seo-ecommerce-ia',path: '/servicios/seo-ecommerce-ia',getParentRoute: () => rootRouteImport
          })
const ServiciosSeoLocalIaRoute = ServiciosSeoLocalIaRouteImport.update({
            id: '/servicios/seo-local-ia',path: '/servicios/seo-local-ia',getParentRoute: () => rootRouteImport
          })
const ServiciosSeoWebIaRoute = ServiciosSeoWebIaRouteImport.update({
            id: '/servicios/seo-web-ia',path: '/servicios/seo-web-ia',getParentRoute: () => rootRouteImport
          })
const ServiciosSeoEcommerceCiudadRoute = ServiciosSeoEcommerceCiudadRouteImport.update({
            id: '/servicios/seo-ecommerce/$ciudad',path: '/servicios/seo-ecommerce/$ciudad',getParentRoute: () => rootRouteImport
          })
const ServiciosSeoLocalCiudadRoute = ServiciosSeoLocalCiudadRouteImport.update({
            id: '/servicios/seo-local/$ciudad',path: '/servicios/seo-local/$ciudad',getParentRoute: () => rootRouteImport
          })
const ServiciosSeoWebCiudadRoute = ServiciosSeoWebCiudadRouteImport.update({
            id: '/servicios/seo-web/$ciudad',path: '/servicios/seo-web/$ciudad',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgenciaGeoMadridRoute: AgenciaGeoMadridRoute,AgenciaSeoRoute: AgenciaSeoRoute,AgenciaSeoCercaDeMiRoute: AgenciaSeoCercaDeMiRoute,AgenciaSeoMadridRoute: AgenciaSeoMadridRoute,AgendaConsultoriaRoute: AgendaConsultoriaRoute,AngelRuzRoute: AngelRuzRoute,CasosExitoRoute: CasosExitoRoute,ComoFuncionaSeoLocalIaRoute: ComoFuncionaSeoLocalIaRoute,ConsultorSeoMadridRoute: ConsultorSeoMadridRoute,CualMejorAgenciaSeoIaEspanaRoute: CualMejorAgenciaSeoIaEspanaRoute,DondeContratarSeoLocalCercaRoute: DondeContratarSeoLocalCercaRoute,FaqsRoute: FaqsRoute,IntegracionIaSeoRoute: IntegracionIaSeoRoute,MasServiciosRoute: MasServiciosRoute,PosicionamientoWebRoute: PosicionamientoWebRoute,PosicionamientoWebMadridRoute: PosicionamientoWebMadridRoute,ProgramaAgenciasRoute: ProgramaAgenciasRoute,QuienesSomosRoute: QuienesSomosRoute,SeoDashboardRoute: SeoDashboardRoute,SeoLocalVsGeoPosicionamientoRoute: SeoLocalVsGeoPosicionamientoRoute,SobreNosotrosRoute: SobreNosotrosRoute,ZonasExclusivasRoute: ZonasExclusivasRoute,BlogSlugRoute: BlogSlugRoute,BlogAtlasChatgptSeoLocalRoute: BlogAtlasChatgptSeoLocalRoute,BlogVisibilidadIaEmpresasRoute: BlogVisibilidadIaEmpresasRoute,CrmLoginRoute: CrmLoginRoute,LegalCondicionesUsoRoute: LegalCondicionesUsoRoute,LegalCookiesRoute: LegalCookiesRoute,LegalPrivacidadRoute: LegalPrivacidadRoute,LegalTerminosServicioRoute: LegalTerminosServicioRoute,ServiciosCreacionEcommerceShopifyRoute: ServiciosCreacionEcommerceShopifyRoute,ServiciosCreacionWebReactRoute: ServiciosCreacionWebReactRoute,ServiciosGeoSeo360Route: ServiciosGeoSeo360Route,ServiciosGestionResenasIaRoute: ServiciosGestionResenasIaRoute,ServiciosGoogleMerchantIaRoute: ServiciosGoogleMerchantIaRoute,ServiciosLinkBuildingInteligenteRoute: ServiciosLinkBuildingInteligenteRoute,ServiciosPublicidadSemIaRoute: ServiciosPublicidadSemIaRoute,ServiciosSeoEcommerceIaRoute: ServiciosSeoEcommerceIaRoute,ServiciosSeoLocalIaRoute: ServiciosSeoLocalIaRoute,ServiciosSeoWebIaRoute: ServiciosSeoWebIaRoute,BlogIndexRoute: BlogIndexRoute,CrmIndexRoute: CrmIndexRoute,ServiciosSeoEcommerceCiudadRoute: ServiciosSeoEcommerceCiudadRoute,ServiciosSeoLocalCiudadRoute: ServiciosSeoLocalCiudadRoute,ServiciosSeoWebCiudadRoute: ServiciosSeoWebCiudadRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)